var cache = null

export default function(o, done){

  var server = o.util.getUrl('frontend')

  if(cache){
    requestAnimationFrame(function(){
      done(cache)
    })
  } else {
    $.ajax({
      url: `${server}?type=movies`,
      type: "GET",
      cache: false,
      headers: { "cache-control": "no-cache" },
    })
    .done(function(data, textStatus, jqXHR) {
      cache = _.filter(data, "public")
      done(cache)
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error('error loading movies data')
      done()
    })
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/data/movies/movies.js